// todo - where does this kind of 'model' belong (e.g. not data but not component)
export type Filter<T> = {
  options: T[];
  selectedValue: T;
  setSelectedValue: React.Dispatch<React.SetStateAction<T>>;
  resetValue?: T;
};

export type MultiFilter<T> = {
  options: T[];
  selectedValues: T[];
  setSelectedValues: React.Dispatch<React.SetStateAction<T[]>>;
};

export function toggleMultiFilterOption<T>(filter: MultiFilter<T>, option: T) {
  if (filter.selectedValues.includes(option)) {
    filter.setSelectedValues(filter.selectedValues.filter((v) => v !== option));
  } else {
    filter.setSelectedValues([...filter.selectedValues, option]);
  }
}

export function resetFilter<T>(filter: Filter<T>) {
  var value = filter.options[0];
  if (
    filter.resetValue !== undefined &&
    filter.options.includes(filter.resetValue)
  ) {
    value = filter.resetValue;
  }

  filter.setSelectedValue(value);
}

export function selectAll<T>(filter: MultiFilter<T>) {
  filter.setSelectedValues(filter.options);
}

export function deselectAll<T>(filter: MultiFilter<T>) {
  filter.setSelectedValues([]);
}

export function resetMultiFilter<T>(filter: MultiFilter<T>) {
  selectAll(filter);
}

export function getToggleAllText<T>(filter: MultiFilter<T>) {
  return filter.selectedValues.length === 0 ? "Select All" : "Deselect All";
}

export function toggleAllMultiFilter<T>(filter: MultiFilter<T>) {
  if (filter.selectedValues.length > 0) {
    deselectAll(filter);
  } else {
    selectAll(filter);
  }
}
